import PropTypes from "prop-types"
import React, { useEffect, useRef } from "react"
import { Button } from "reactstrap"
// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

const SidebarContent = props => {
  const ref = useRef()
  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li
              className="menu-title"
              style={{
                font: "Archivo",
                fontWeight: "600",
                fontStyle: "SemiBold",
                fontSize: "15px",
                color: "#00578E",
                lineHeight: "13px",
                letterSpacing: "0.5px",
                marginLeft: "6px",
              }}
            >
              {props.t("Menu")}
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="fas fa-user"></i>
                <span>{props.t("Manage Profile")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/profile">{props.t("Personal")}</Link>
                </li>
                <li>
                  <Link to="/Addresses">{props.t("Addresses")}</Link>
                </li>
                <li>
                  <Link to="/managepaymentsaccounts">
                    {props.t("Payments Accounts")}
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="fas fa-truck"></i>
                <span>{props.t("Manage Supplier")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/ViewSeller">{props.t("Bizz Profile")}</Link>
                </li>
                <li>
                  <Link to="/Products">{props.t("Products")}</Link>
                </li>
                <li>
                  <Link to="/ProductVarients">
                    {props.t("Product Varients")}
                  </Link>
                </li>
                <li>
                  <Link to="/ReceiptAccounts">
                    {props.t("Receipt Accounts")}
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="fas fa-users"></i>
                <span>{props.t("Manage Salesman")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/AddSalesman">{props.t("New Salesman")}</Link>
                </li>
                <li>
                  <Link to="/SalesmanList">{props.t("Salesman List")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-collection"></i>
                <span>{props.t("Manage Subscription")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/Subscriptions">{props.t("Subscriptions")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="fas fa-tags"></i>
                <span>{props.t("Manage Promotions")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/Deals">{props.t("Deals")}</Link>
                </li>
                <li>
                  <Link to="/Advertisements">{props.t("Advertisements")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bxs-shield"></i>
                <span>{props.t("Manage Security")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/ChangePassword">{props.t("Change Password")}</Link>
                </li>
                <li>
                  <Link to="/ChangeSecurityPin">
                    {props.t("Change Security Pin")}
                  </Link>
                </li>
                <li>
                  <Link to="/TermsAndConditions">
                    {props.t("Terms & Conditions")}
                  </Link>
                </li>
                <li>
                  <Link to="/PrivacyPolicy">{props.t("Privacy & Policy")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-shield-quarter"></i>
                <span>{props.t("Manage General")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/notifications">
                    {props.t("Push Notifications")}
                  </Link>
                </li>
                {/* <li>
                  <Link to="/notifications">{props.t("Set Remainder")}</Link>
                </li> */}
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-help-circle"></i>
                <span>{props.t("About")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/AboutUs">{props.t("About Us")}</Link>
                </li>
                <li>
                  <Link to="/ContactUs">{props.t("Contact Us")}</Link>
                </li>
                <li>
                  <Link to="/FAQ">{props.t("FAQ")}</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-support"></i>
                <span>{props.t("Help")}</span>
              </Link>
              <ul className="sub-menu">
                <li>
                  <Link to="/SupplierHelp">{props.t("Support Center")}</Link>
                </li>
              </ul>
            </li>
            {/* <hr />
            <li className="text-center mt-3">
              <Link to="/logout">
                <Button color="primary" className="w-75">
                  <span
                    style={{
                      font: "Poppins",
                      fontWeight: "500",
                      fontSize: "18px",
                      color: "#fff",
                      lineHeight: "13px",
                      letterSpacing: "0.5px",
                    }}
                  >
                    {props.t("Logout")}
                  </span>
                </Button>
              </Link>
            </li> */}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
